<div class="col-12 mainContent">
    <div class="col-3 left">
        <div id="scrollfix">
            <div class="tab">
                <label class="{{SearchType=='buyer' ? 'active' : ''}}" (click)="SetQuery('buyer')">買主搜尋</label>
                <label class="{{SearchType=='act' ? 'active' : ''}}" (click)="SetQuery('act')">採購案搜尋</label>
            </div>
    
            <ng-container *ngIf="SearchType == 'buyer'">
                <buyer-select (ChangeEvt)="BuyerSet($event)"></buyer-select>
            </ng-container>
            <ng-container *ngIf="SearchType == 'act'">
                <act-select (ChangeEvt)="ActSet($event)"></act-select>
            </ng-container>
    
            <div class="btn" (click)="AddToTag()">加入搜尋條件</div>
    
            <div class="checkbox">
                <label for="c1">隱藏「取消來台」買主</label>
                <label class="switch">
                    <input type="checkbox" (change)="BuyerEvt($event)"/>
                    <span class="slider round"></span>
                 </label>
            </div>
        </div>
    </div>
    <div class="col-9 right">
        <h1>搜尋結果 <span class="total" *ngIf="BuyerData">共有 {{BuyerPager['totalRows']}} 筆結果</span></h1>
   
        <div class="search" *ngIf="BuyerData">

            <div class="term" *ngIf="TagGroup.length > 0">
                <ng-container *ngFor="let item of TagGroup;let _g = index;">
                    <div *ngIf="item.tag.length > 0" class="tag {{ (_g == 0) ? 'first' : '' }}" >
                        <label>{{item.name}}</label>
                        <p>
                            <ng-container *ngFor="let _child of item.tag;">
                                <label>{{_child.name}}<i class="icon icon-close" (click)="RemoveTag(_child.tag_index)">&#xe802;</i></label>
                            </ng-container>
                        </p>
                    </div>
                </ng-container>
            </div>
            <div style="margin-bottom:2rem;"></div>
            <div class="content animated fadeIn">

                <empty *ngIf="BuyerData.length == 0"></empty>
                <!-- status valid 可報名
                status regist 已報名
                status full 已額滿
                status deadline 報名截止
                status cancel 買主取消 -->
                <ng-container *ngFor="let item of BuyerData">
                    <buyerCard [Data]="item"></buyerCard>
                </ng-container>
                <!-- <div class="card">
                    <div class="info">
                        <div class="status full">已額滿</div>
                        <label>EXATI TECNOLOGIA E DESENVOLVIMENTO DE SISTEMAS LTDA</label>
                        <p>
                            <span class="date">2020/12/22</span>
                            <span class="area">巴西(南美)</span>
                            <span class="tag">資通訊電子零組件／綠能產品</span>
                        </p>
                    </div>
                    <div class="divider"></div>
                    <div class="tags">
                        <span>LED Driver (Power Supply)</span>
                        <span>Electronic Components</span>
                        <span>PCB(OEM)</span>
                        <span>PCB(OEM)</span>
                        <span>PCB(OEM)</span>
                    </div>
                </div>-->
                <pagination *ngIf="BuyerPager" [Pager]="BuyerPager" (PageSetEvt)="SetBuyerPage($event)"></pagination>
            </div>
        </div>

        <!-- <div class="case term" *ngIf="ActData && SearchType == 'act'">
            <div class="term">
                <ng-container *ngFor="let item of TagGroup;let _g = index;">
                    <div *ngIf="item.tag.length > 0" class="tag {{ (_g == 0) ? 'first' : '' }}" >
                        <label>{{item.name}}</label>
                        <p>
                            <ng-container *ngFor="let _child of item.tag;">
                                <label>{{_child.name}}<i class="icon icon-close" (click)="RemoveTag(_child.tag_index)">&#xe802;</i></label>
                            </ng-container>
                        </p>
                    </div>
                </ng-container>
            </div>
            <div style="margin-bottom:2rem;" *ngIf="TagGroup.length > 0"></div>

            <div class="content animated fadeIn" *ngIf="ActData && SearchType == 'act'">

                <ng-container *ngFor="let item of ActData">

                    <div class="card {{item.statusClass}}" routerLink="/activity/{{item.id}}">
                        <div class="item">
                            <div class="status"><span>{{item.statusName}}</span></div>
                            <span class="date {{(item.is_new) ? 'lasted' : ''}}">{{item.eventShortDate}}</span>
                            <label>{{item.name}}</label>
                            <p>
                                <span class="date">報名日期｜{{item.enrollDate}}</span>
                                <span class="info">{{item.typeName}}</span>
                            </p>
                            <a routerLink="/activity/{{item.id}}"><span class="view">查看詳情</span></a>
                        </div>
                    </div>

                </ng-container>

                <pagination *ngIf="ActPager" [Pager]="ActPager" (PageSetEvt)="SetActPage($event)"></pagination>
            </div>
        </div> -->
    </div>
</div>